"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailTemplateToJSON = exports.EmailTemplateFromJSONTyped = exports.EmailTemplateFromJSON = void 0;
function EmailTemplateFromJSON(json) {
    return EmailTemplateFromJSONTyped(json, false);
}
exports.EmailTemplateFromJSON = EmailTemplateFromJSON;
function EmailTemplateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'html_content': json['html_content'],
        'subject': json['subject'],
        'plain_content': json['plain_content'],
    };
}
exports.EmailTemplateFromJSONTyped = EmailTemplateFromJSONTyped;
function EmailTemplateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'html_content': value.html_content,
        'subject': value.subject,
        'plain_content': value.plain_content,
    };
}
exports.EmailTemplateToJSON = EmailTemplateToJSON;
